// import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import { LazyMotion, domAnimation } from 'motion/react';
import { BrowserRouter } from 'react-router-dom';
import { showConsole } from '@/utils/Location';
import { createRoot } from 'react-dom/client';
import { Application } from '@/Application';
import { Provider } from 'react-redux';
// import { useEffect } from 'react';
import { bind } from 'cuelume';
import Store from '@/redux';
import '@/styles/index.css';

/* import {
  useLocation,
  matchRoutes,
  BrowserRouter,
  useNavigationType,
  createRoutesFromChildren
} from 'react-router-dom'; */

/* import {
  init as Sentry,
  replayIntegration,
  captureConsoleIntegration
  // reactRouterV6BrowserTracingIntegration
} from '@sentry/react'; */

bind();

showConsole();

/* !!import.meta.env.VITE_SENTRY_DSN &&
  Sentry({
    tracePropagationTargets: [`${import.meta.env.VITE_API_BASE_URL}/api`],
    tracesSampleRate: +import.meta.env.VITE_SENTRY_SAMPLE_RATE || 0.0,
    dsn: import.meta.env.VITE_SENTRY_DSN,
    environment: import.meta.env.MODE,
    // replaysSessionSampleRate: 0.1,
    // replaysOnErrorSampleRate: 1.0,

    integrations: [
      replayIntegration(),

      captureConsoleIntegration({
        levels: import.meta.env.VITE_SENTRY_LOG_CAPTURE_LEVELS?.split(', ')
      })

      // reactRouterV6BrowserTracingIntegration({
      //   useEffect,
      //   useLocation,
      //   useNavigationType,
      //   createRoutesFromChildren,
      //   matchRoutes
      // })
    ],

    ignoreErrors: [
      'Non-Error promise rejection captured',
      'McD Bridge already initialized',
      'Non-Error exception captured'
    ]
  }); */

const ApplicationWrapper = (
  <LazyMotion features={domAnimation} strict>
    <Provider store={Store}>
      <BrowserRouter>
        <Application />
      </BrowserRouter>
    </Provider>
  </LazyMotion>
);

createRoot(document.body).render(
  /* import.meta.env.VITE_RECAPTCHA_ENTERPRISE_KEY ? (
    <GoogleReCaptchaProvider
      reCaptchaKey={import.meta.env.VITE_RECAPTCHA_ENTERPRISE_KEY}
      useEnterprise
    >
      {ApplicationWrapper}
    </GoogleReCaptchaProvider>
  ) : */ ApplicationWrapper
);
